export default "__VITE_ASSET__BYn4xdDE__"